import QuizStatuses from '@/constants/QuizStatuses'
import slideGetters from './slide'
import audienceGetter from './audience'

export default {
  ...audienceGetter,
  ...slideGetters,
  isEnableABTestQuiz: (state) => {
    console.log('isEnableABTestQuiz')
    if (!state.presentation) return false
    if (state.presentation.userId % 10 > 2) return true
    return false
  },
  isWaitingQuizResult: (state) => {
    const { slide, presentation } = state
    if (!slide) return false
    if (!presentation.manualRevealCorrectAnswers) return false
    return slide.type === 'pickAnswer' && slide.quizStatus === QuizStatuses.RESULT_SCREEN && !slide.showCorrectOption
  },
  canShowQuizResult: (state, getters) => {
    const isResultScreen = getters.activeActivity.quizStatus === QuizStatuses.RESULT_SCREEN
    if (!state.presentation.manualRevealCorrectAnswers || state.presentation.audiencePacing) {
      return isResultScreen
    }
    return getters.activeActivity.showCorrectOption && isResultScreen
  },
  isEnableFeedback(state) {
    return state.presentation?.isEnablePrivateFeedback
  },
  isEnableSlideReview(state) {
    return state.presentation?.isEnableAudienceReviewSlides
  },
}
